export default __webpack_public_path__ + "static/1048-0527094e0df5f2078db7b1568eab1f93.gif";